import TrackingOverview from "./Overview.vue";
import LiveJourneys from "./LiveJourneys.vue";
import Sessions from "./Sessions.vue";
import SessionDetail from "./SessionDetail.vue";
import Funnel from "./Funnel.vue";
import Traffic from "./Traffic.vue";
import Errors from "./Errors.vue";
import Apis from "./Apis.vue";
import Capacity from "./Capacity.vue";
import Support from "./Support.vue";
import Issues from "./Issues.vue";
import WeeklyReport from "./WeeklyReport.vue";
import GpsAi from "./GpsAi.vue";

/**
 * All onboarding-tracking routes, nested under the same parent (auth'd) layout
 * as the rest of the admin app. Any app using OnboardingTrackingService can add
 * the whole feature with `children: [...otherRoutes, ...onboardingTrackingRoutes]`.
 */
export const onboardingTrackingRoutes = [
  {
    path: "tracking/overview",
    name: "Tracking Overview",
    component: TrackingOverview,
    meta: { description: "", requiresAuth: true },
  },
  {
    path: "tracking/live-journeys",
    name: "Live Journeys",
    component: LiveJourneys,
    meta: { description: "", requiresAuth: true },
  },
  {
    path: "tracking/sessions",
    name: "Tracking Sessions",
    component: Sessions,
    meta: { description: "", requiresAuth: true },
  },
  {
    path: "tracking/sessions/:sessionId",
    name: "Tracking Session Detail",
    component: SessionDetail,
    props: true,
    meta: { description: "", requiresAuth: true },
  },
  {
    path: "tracking/funnels",
    name: "Conversion Funnels",
    component: Funnel,
    meta: { description: "", requiresAuth: true },
  },
  {
    path: "tracking/traffic",
    name: "Tracking Traffic",
    component: Traffic,
    meta: { description: "", requiresAuth: true },
  },
  {
    path: "tracking/errors",
    name: "Tracking Errors",
    component: Errors,
    meta: { description: "", requiresAuth: true },
  },
  {
    path: "tracking/apis",
    name: "Tracking APIs",
    component: Apis,
    meta: { description: "", requiresAuth: true },
  },
  {
    path: "tracking/capacity",
    name: "Capacity & Demand",
    component: Capacity,
    meta: { description: "", requiresAuth: true },
  },
  {
    path: "tracking/support",
    name: "Support Insights",
    component: Support,
    meta: { description: "", requiresAuth: true },
  },
  {
    path: "tracking/issues",
    name: "Issues & Changes",
    component: Issues,
    meta: { description: "", requiresAuth: true },
  },
  {
    path: "tracking/gps-ai",
    name: "GPS AI",
    component: GpsAi,
    meta: { description: "", requiresAuth: true },
  },
  {
    path: "tracking/weekly-report",
    name: "Weekly Report",
    component: WeeklyReport,
    meta: { description: "", requiresAuth: true },
  },
];

export default onboardingTrackingRoutes;
